import { Cliente } from '../../pessoa/cliente/cliente';
import { Representante } from '../../pessoa/representante/representante';

/** Utilizada para congelar um cliente */
export class ClienteCarteiraCongelar {
    idCliente: number;
    cliente: Cliente;
    representante: Representante;
    idMotivoCongelamento: number;
    justificativaCongelamento: string;
}
